
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clases/curso-official-product-owner-1",
      function () {
        return require("private-next-pages/clases/curso-official-product-owner-1.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clases/curso-official-product-owner-1"])
      });
    }
  